/**
 * @fileoverview Embedding data source and type definitions.
 */

import { EMBEDDING_STATUS, EmbeddingSchema, type Embedding } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createCreatedAtField, createDateTimeField, createIdField, createNumberField, createSelectField, createStringField, createUpdatedAtField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';
import { createOptionLoader } from './option-loader';

export type { Embedding };

const noteLoader = createOptionLoader('note', 'title');

const statusOptions = Object.values(EMBEDDING_STATUS).map((status) => ({
  value: status,
  label: status.charAt(0).toUpperCase() + status.slice(1),
}));

export const embeddingDataSource = createBaseDataSource<Embedding>({
  endpoint: 'embedding',
  searchField: 'note_id',
  schema: EmbeddingSchema,
  fields: [
    createIdField(FIELD_WIDTHS.SMALL),
    createSelectField('note_id', 'Note', noteLoader.getOptions(), FIELD_WIDTHS.MEDIUM),
    createSelectField('status', 'Status', statusOptions, FIELD_WIDTHS.SMALL),
    createNumberField('retry_count', 'Retries', FIELD_WIDTHS.TINY),
    createStringField('error_message', 'Error', FIELD_WIDTHS.LARGE),
    createDateTimeField('processing_started_at', 'Started', FIELD_TYPE_WIDTHS.DATE, false),
    createDateTimeField('completed_at', 'Completed', FIELD_TYPE_WIDTHS.DATE, false),
    createCreatedAtField(FIELD_TYPE_WIDTHS.DATE),
    createUpdatedAtField(FIELD_TYPE_WIDTHS.DATE),
  ],
});

export const embeddingCache = getCache('embedding');
